// extracted by mini-css-extract-plugin
export default {"searchbar":"SearchBar_searchbar__2JqKw","content":"SearchBar_content__X+8cr","label":"SearchBar_label__YEqJp","textfield":"SearchBar_textfield__9NdT0"};